import { render } from "./LoadingSpinner.vue?vue&type=template&id=71b29f6e&scoped=true&ts=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=71b29f6e&lang=postcss&scoped=true"

import exportComponent from "/home/motoko/Workbench/dyna/dj/client/node_modules/.pnpm/vue-loader@16.8.2_webpack@5.60.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b29f6e"]])

export default __exports__